import React from 'react';

import {
  ACT_RECORD_FIELD_NAMES,
  ACT_RECORD_NUMBER_REGEXP,
  ACT_RECORD_NUMBER_OLD_REGEXP
} from '../../../constants/actRecord';
import { getActRecordVersionByDate } from '../../../helpers/actRecord';

import MaskedField from '../../MaskedField/MaskedField';

const ActRecordNumberField = props => {
  const { actRecordData, blurred, onChange, onBlur, saveDraft } = props;
  const numberFieldData = actRecordData[ACT_RECORD_FIELD_NAMES.number];
  const dateFieldData = actRecordData[ACT_RECORD_FIELD_NAMES.date];
  const maxLength = 21;
  let mask = ACT_RECORD_NUMBER_REGEXP.FROM_INPUT_MASK;

  if (getActRecordVersionByDate(dateFieldData.value) === 'OLD') {
    mask = ACT_RECORD_NUMBER_OLD_REGEXP.FROM_INPUT_MASK;
  }

  const handleChange = ev => {
    onChange(ev);
    saveDraft();
  };

  const handleBlur = ev => {
    onBlur(ev.target.name);
    saveDraft();
  };

  return (
    <MaskedField
      label="Номер актовой записи"
      maxLength={maxLength}
      name={ACT_RECORD_FIELD_NAMES.number}
      value={numberFieldData.value}
      error={blurred ? numberFieldData.error : false}
      errorLocation="placeholder"
      disabled={!dateFieldData.value}
      onChange={handleChange}
      onBlur={handleBlur}
      className="ActRecord__number"
      maskOptions={{
        regex: mask,
        showMaskOnHover: false,
        casing: 'upper',
        greedy: false
      }}
    />
  );
};

export default ActRecordNumberField;
